var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-engineers-security-group-detail" },
    [
      _c("div", [
        _c(
          "a",
          {
            staticClass: "nav-back",
            attrs: { id: "settings-engineers-security-group-detail-back" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("back")) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "detail" }, [
        _c("label", { staticClass: "emphasis" }, [
          _vm._v(
            _vm._s(
              _vm.groupDetail.name === _vm.AdminRoleName[0]
                ? _vm.$t("settings.security.systemAdmin")
                : _vm.groupDetail.name
            )
          ),
        ]),
        _vm._v(" "),
        _vm.allowChangeDescription
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.groupDescription,
                    expression: "groupDescription",
                  },
                ],
                class: { red: _vm.highlight },
                attrs: {
                  id: "settings-engineers-security-group-detail-name",
                  type: "text",
                },
                domProps: { value: _vm.groupDescription },
                on: {
                  focusout: function ($event) {
                    return _vm.updateGroupDescription()
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.groupDescription = $event.target.value
                  },
                },
              }),
            ])
          : _c("div", [
              _c(
                "pre",
                {
                  on: {
                    dblclick: function ($event) {
                      return _vm.dblClickEdit()
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.groupDescription))])]
              ),
              _vm._v(" "),
              _vm.aclHelper.getSettingsUpdateAccess()
                ? _c("a", {
                    staticClass: "fa fa-pencil icon",
                    attrs: {
                      id: "settings-engineers-security-group-detail-name-edit",
                    },
                    on: {
                      click: function ($event) {
                        _vm.allowChangeDescription = true
                      },
                    },
                  })
                : _vm._e(),
            ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "users" }, [
        _c("table", [
          _c("thead", [
            _c("th", [
              _vm._v(
                _vm._s(_vm.userHeaders[0].name) +
                  " (" +
                  _vm._s(_vm.filteredItems.length) +
                  ")"
              ),
            ]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.userHeaders[1].name))]),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm.userItems.length > 0
                ? _c("tr", [
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userHeaders[0].filter,
                            expression: "userHeaders[0].filter",
                          },
                        ],
                        attrs: {
                          id: "settings-engineers-security-group-detail-user-filter",
                          type: "text",
                        },
                        domProps: { value: _vm.userHeaders[0].filter },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userHeaders[0],
                              "filter",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "settings-filter" },
                      [
                        _c("HKLSelect", {
                          staticClass: "align-center",
                          attrs: {
                            value: _vm.userHeaders[1].filter,
                            "settings-filter-row": "",
                            options: _vm.userStatusHklOptions,
                            showSearch: false,
                            placeholder: "",
                          },
                          on: {
                            change: function (val) {
                              _vm.userHeaders[1].filter = val
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.filteredItems, function (item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [
                    _c(
                      "a",
                      {
                        attrs: {
                          id:
                            "settings-engineers-security-group-detail-user-detail-" +
                            index,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.navToUserDetail(item.id)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.userName(item)) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", { staticClass: "status" }, [
                      _vm._v(_vm._s(_vm._f("showStatusLabel")(item.enabled))),
                    ]),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }